import { Company } from 'interfaces'
import { NOTIFICATION_ACTION_TYPES } from './notification.constants'
import { check } from 'prettier'
import { Setup } from '@storybook/addon-a11y'

class NotificationError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'NotificationError'
  }
}

interface ReduxAction<T, O> {
  type: T
  object: O
}

type SetupNotificationListenerAction =
  | ReduxAction<
      NOTIFICATION_ACTION_TYPES.SETUP_NOTIFICATION_LISTENER_REQUEST,
      undefined
    >
  | ReduxAction<
      NOTIFICATION_ACTION_TYPES.SETUP_NOTIFICATION_LISTENER_SUCCESS,
      undefined
    >
  | ReduxAction<
      NOTIFICATION_ACTION_TYPES.SETUP_NOTIFICATION_LISTENER_FAILURE,
      NotificationError
    >

type CheckNotificationAvailabilityAction =
  | ReduxAction<
      NOTIFICATION_ACTION_TYPES.CHECK_NOTIFICATION_AVAILABILITY_REQUEST,
      undefined
    >
  | ReduxAction<
      NOTIFICATION_ACTION_TYPES.CHECK_NOTIFICATION_AVAILABILITY_SUCCESS,
      boolean
    >
  | ReduxAction<
      NOTIFICATION_ACTION_TYPES.CHECK_NOTIFICATION_AVAILABILITY_FAILURE,
      NotificationError
    >

type RegisterRemoteNotificationAction =
  | ReduxAction<
      NOTIFICATION_ACTION_TYPES.REGISTER_REMOTE_NOTIFICATION_REQUEST,
      string[]
    >
  | ReduxAction<
      NOTIFICATION_ACTION_TYPES.REGISTER_REMOTE_NOTIFICATION_SUCCESS,
      undefined
    >
  | ReduxAction<
      NOTIFICATION_ACTION_TYPES.REGISTER_REMOTE_NOTIFICATION_FAILURE,
      NotificationError
    >

type SubscribeToTopicAction =
  | ReduxAction<NOTIFICATION_ACTION_TYPES.SUBSCRIBE_TO_TOPICS_REQUEST, string[]>
  | ReduxAction<NOTIFICATION_ACTION_TYPES.SUBSCRIBE_TO_TOPICS_SUCCESS, string[]>
  | ReduxAction<
      NOTIFICATION_ACTION_TYPES.SUBSCRIBE_TO_TOPICS_FAILURE,
      NotificationError
    >

type UnsubscribeToTopicAction =
  | ReduxAction<
      NOTIFICATION_ACTION_TYPES.UNSUBSCRIBE_FROM_TOPICS_REQUEST,
      string[]
    >
  | ReduxAction<
      NOTIFICATION_ACTION_TYPES.UNSUBSCRIBE_FROM_TOPICS_SUCCESS,
      string[]
    >
  | ReduxAction<
      NOTIFICATION_ACTION_TYPES.UNSUBSCRIBE_FROM_TOPICS_FAILURE,
      NotificationError
    >

type NotificationAction =
  | SetupNotificationListenerAction
  | CheckNotificationAvailabilityAction
  | RegisterRemoteNotificationAction
  | SubscribeToTopicAction
  | UnsubscribeToTopicAction

const setupNotificationListener = () => {
  return {
    type: NOTIFICATION_ACTION_TYPES.SETUP_NOTIFICATION_LISTENER_REQUEST
  }
}

const checkNotificationAvailability = () => {
  return {
    type: NOTIFICATION_ACTION_TYPES.CHECK_NOTIFICATION_AVAILABILITY_REQUEST
  }
}

const requestNotifications = (initialCompanies: Company[]) => {
  return {
    type: NOTIFICATION_ACTION_TYPES.REGISTER_REMOTE_NOTIFICATION_REQUEST,
    object: initialCompanies
  }
}

const subscribeTo = (channels: Company[]) => {
  return {
    type: NOTIFICATION_ACTION_TYPES.SUBSCRIBE_TO_TOPICS_REQUEST,
    object: channels
  }
}

const unsubscribeFrom = (channels: Company[]) => {
  return {
    type: NOTIFICATION_ACTION_TYPES.UNSUBSCRIBE_FROM_TOPICS_REQUEST,
    object: channels
  }
}

const notificationActions = {
  setupNotificationListener,
  checkNotificationAvailability,
  requestNotifications,
  subscribeTo,
  unsubscribeFrom
}

export default notificationActions
export type { NotificationAction }
